import { Modal,Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { openImgModal } from './HRTrainingInfo';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme} from '@mui/material/styles';

const style = {
    position: 'absolute',
    left: '50%',
    top:"50%",
    transform: 'translate(-50%,-50%)',
};

const ImgModal = () => {
    const theme = useTheme();
    const openModal = useSelector((state)=>state.hrtraining.openModal);
    const imgEl = useSelector((state)=>state.hrtraining.imgEl);
    const dispatch = useDispatch();
    const matches = useMediaQuery(theme.breakpoints.up('lg'));
    let width = "";
    let height = "";
    if(matches){
        if(imgEl.width){
            width = "70vw";
            height = "40vw";
        }
        else{
            width = "35vw";
            height = "50vw";
        }
    }
    else{
        if(imgEl.width){
            width = "80vw";
            height = "60vw";
        }
        else{
            width = "50vw";
            height = "70vw";
        } 
    }
    const handleModalClose = () => {
        dispatch(openImgModal(false))
    }
    return (
        <Modal open={openModal} onClose={handleModalClose} sx={{ backgroundColor: "rgba(0,0,0,0.2)" }}>
            <>
                <Box sx={{...style}}>
                    <img src={imgEl.src} style={{width:width,height:height,maxHeight:"100vh"}} alt={imgEl.alt}/>
                </Box>
            </>

        </Modal>
    );
}

export default ImgModal;